import { useState } from "react";
import { afrostalgia2imgs } from "../data/galleryimgdata"

const Afrostalgia2 = () => {
     const [selectedImage, setSelectedImage] = useState(null);
     const [currentIndex, setCurrentIndex] = useState(0);

     const openImage = (index) => {
          setCurrentIndex(index);
          setSelectedImage(afrostalgia2imgs[index].image);
     };

     const closeImage = () => {
          setSelectedImage(null);
     };

     const prevImage = () => {
          const newIndex = (currentIndex - 1 + afrostalgia2imgs.length) % afrostalgia2imgs.length;
          setCurrentIndex(newIndex);
          setSelectedImage(afrostalgia2imgs[newIndex].image);
     };

     const nextImage = () => {
          const newIndex = (currentIndex + 1) % afrostalgia2imgs.length;
          setCurrentIndex(newIndex);
          setSelectedImage(afrostalgia2imgs[newIndex].image);
     };

     return (
          <>
               <h1>Afrostalgia 2</h1>
               <div className="gallery-images-container">
                    {afrostalgia2imgs.map((afrostalgia2, index) => (
                         <img
                              alt="afrostalgia"
                              src={afrostalgia2.image}
                              key={afrostalgia2.id}
                              onClick={() => openImage(index)}
                              style={{ cursor: "pointer" }}
                         />
                    ))}
               </div>

               {selectedImage && (
                    <div className="modal">
                         <span className="close" onClick={closeImage}>&times;</span>
                         <button className="prev" onClick={prevImage}>&#10094;</button>
                         <img src={selectedImage}
                              loading="lazy"
                              alt="Selected" className="modal-content" />
                         <button className="next" onClick={nextImage}>&#10095;</button>
                    </div>
               )}

          </>
     );
};

export default Afrostalgia2;